import { CrudMode, DataDisplay, Grid, pn, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { Input } from "components";
import { StaffPosition, StaffPositionViewResource } from "generated/openApi";
import produce from "immer";

export const StaffPositionPageBody = (props: {
    crudMode: CrudMode;
    staffPosition: StaffPosition;
    setStaffPosition: (value: StaffPosition) => void;
    viewResource: StaffPositionViewResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<StaffPosition>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.staffPosition.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.staffPosition.name}
                onChange={(e) =>
                    props.setStaffPosition(
                        produce(props.staffPosition, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};